/* eslint-disable import/prefer-default-export */
import { ANIMATION_TYPES } from '../../../Data/Lottie';
import {
  setAnimationConfig,
  setAnimationData,
} from '../../../Lib/redux/slices/lottieAnimationData';
import logToConsole from '../../../Utils/logToConsole';

const fetchAnimations = async (type) => {
  try {
    let animationModule;
    // Use literal string paths so webpack can statically analyze and code-split
    switch (type) {
      case ANIMATION_TYPES.MATCHING:
        animationModule = await import(
          /* webpackChunkName: 'animation-matching' */
          // eslint-disable-next-line import/extensions
          '../../../animations/matching.json'
        );
        break;
      case ANIMATION_TYPES.SUCCESS:
        animationModule = await import(
          /* webpackChunkName: 'animation-success' */
          // eslint-disable-next-line import/extensions
          '../../../animations/success.json'
        );
        break;
      case ANIMATION_TYPES.STANDARD:
        animationModule = await import(
          /* webpackChunkName: 'animation-standard' */
          // eslint-disable-next-line import/extensions
          '../../../animations/standard.json'
        );
        break;
      case ANIMATION_TYPES.MATCHING_BRANDED_POS_US:
        animationModule = await import(
          /* webpackChunkName: 'animation-matching-pos' */
          // eslint-disable-next-line import/extensions
          '../../../animations/matching_POS.json'
        );
        break;
      case ANIMATION_TYPES.MATCHING_BRANDED_AUTO_WARRANTY_US:
        animationModule = await import(
          /* webpackChunkName: 'animation-matching-aw' */
          // eslint-disable-next-line import/extensions
          '../../../animations/matching_AW.json'
        );
        break;
      case ANIMATION_TYPES.MATCHING_BRANDED_TELEPHONE_SYSTEMS_US:
        animationModule = await import(
          /* webpackChunkName: 'animation-matching-ts' */
          // eslint-disable-next-line import/extensions
          '../../../animations/matching_TS.json'
        );
        break;
      case ANIMATION_TYPES.MATCHING_BRANDED_PAYROLL_SERVICES_US:
        animationModule = await import(
          /* webpackChunkName: 'animation-matching-payroll' */
          // eslint-disable-next-line import/extensions
          '../../../animations/matching_Payroll.json'
        );
        break;
      case ANIMATION_TYPES.MATCHING_BRANDED_VEHICLE_TRACKING_US:
        animationModule = await import(
          /* webpackChunkName: 'animation-matching-vt' */
          // eslint-disable-next-line import/extensions
          '../../../animations/matching_VT.json'
        );
        break;
      default:
        return null;
    }
    // Convert imported JSON object to JSON string to match Redux state format
    return JSON.stringify(animationModule.default);
  } catch (_error) {
    logToConsole.warn('[LOTTIE] Failed to load optional animation dependency');
    return undefined;
  }
};

/*
 * Loads the required animation JSON files for the loader animations, and
 * the submission success animation. it removes the need to load the same
 * animation JSON multiple times.
 */
const getRequiredAnimationJson = async (loaderConfig) => {
  const uniqueLoaderAnimationTypes = Array.from(
    new Set(
      Object.keys(loaderConfig)
        .map((key) => loaderConfig[key].animationType)
        .concat([ANIMATION_TYPES.SUCCESS]) // Success animation is always required for the submission success animation
    )
  );

  const loaderConfigAnimationTypes = {};
  await Promise.all(
    uniqueLoaderAnimationTypes.map(async (type) => {
      loaderConfigAnimationTypes[type] = await fetchAnimations(type);
    })
  );

  return loaderConfigAnimationTypes;
};

export const loadRemoteAnimationJsonFiles = async (loaderConfig, dispatch) => {
  const loaderConfigAnimationJson = await getRequiredAnimationJson(
    loaderConfig
  );

  const reformattedLoaderConfig = Object.keys(loaderConfig).reduce(
    (acc, key) => {
      // eslint-disable-next-line no-param-reassign
      acc[key] = { ...loaderConfig[key] };
      return acc;
    },
    {}
  );

  Object.keys(reformattedLoaderConfig).forEach((key) => {
    const jsonData =
      loaderConfigAnimationJson[reformattedLoaderConfig[key]?.animationType];
    if (jsonData) {
      reformattedLoaderConfig[key].animationJson = jsonData;
    }
  });

  const animationsLoaded = Object.keys(reformattedLoaderConfig).some(
    (key) => reformattedLoaderConfig[key].animationJson
  );

  if (animationsLoaded) {
    dispatch(setAnimationConfig(reformattedLoaderConfig));
  }

  if (loaderConfigAnimationJson[ANIMATION_TYPES.SUCCESS]) {
    dispatch(
      setAnimationData({
        submissionSuccessAnimationJsonString:
          loaderConfigAnimationJson[ANIMATION_TYPES.SUCCESS],
      })
    );
  }
};
